module.exports = __webpack_public_path__ + "static/media/house-flood.61219697.svg";